import type { RowError } from '../../../../types/admin';

export function ErrorReportTable({ errores }: { errores: RowError[] }): React.JSX.Element {
  return (
    <div className="overflow-hidden rounded-lg border border-border/70 shadow-elegant">
      <table className="w-full text-sm">
        <thead className="bg-muted/40 text-xs font-semibold uppercase tracking-wide text-muted-foreground">
          <tr>
            <th className="px-4 py-2 text-left">Fila</th>
            <th className="px-4 py-2 text-left">Columna</th>
            <th className="px-4 py-2 text-left">Valor</th>
            <th className="px-4 py-2 text-left">Error</th>
          </tr>
        </thead>
        <tbody>
          {errores.map((fila, index) => (
            <tr key={`${fila.fila}-${fila.columna}-${index}`} className="border-t border-border/60">
              <td className="px-4 py-2 tabular-nums">{fila.fila}</td>
              <td className="px-4 py-2 font-medium text-foreground">{fila.columna}</td>
              <td className="px-4 py-2 tabular-nums text-muted-foreground">{fila.valor}</td>
              <td className="px-4 py-2 text-destructive">{fila.error}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
